import { getAvatarChar } from "lib/utils/getAvatarChar";
import { formatCountryLabel } from "lib/utils/countryLabels";
import { formatKoreanDateTime } from "lib/utils/koreanDateTime";
import { formatSystemRole } from "lib/utils/roleLabels";

export default function AdminUsersTableCard({
  users = [],
  selectedId,
  onSelect,
  selectedUser,
  q,
  setQ,
  roleFilter,
  setRoleFilter,
  statusFilter,
  setStatusFilter,
}) {
  return (
    <div className="card usersTableCard">
      <div className="cardHeader">
        <h3>사용자 목록</h3>

        <div className="tableTools">
          <input
            className="searchInput"
            placeholder="이름 또는 이메일 검색"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />

          <select
            className="select"
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
          >
            <option value="all">역할 전체</option>
            <option value="master">{formatSystemRole("master")}</option>
            <option value="admin">{formatSystemRole("admin")}</option>
            <option value="manager">{formatSystemRole("manager")}</option>
            <option value="user">{formatSystemRole("user")}</option>
          </select>

          <select
            className="select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">상태 전체</option>
            <option value="active">활성</option>
            <option value="inactive">비활성</option>
          </select>
        </div>
      </div>

      <div className="tableWrap">
        <table className="usersTable">
          <thead>
            <tr>
              <th>사용자</th>
              <th>역할</th>
              <th>국가</th>
              <th>상태</th>
              <th className="tRight">최근 로그인 시도</th>
            </tr>
          </thead>

          <tbody>
            {users.map((u) => (
              <tr
                key={u.id}
                className={u.id === selectedId ? "active" : ""}
                onClick={() => onSelect(u.id)}
              >
                <td>
                  <div className="userCell">
                    <div className="avatar">{getAvatarChar(u.user_name)}</div>
                    <div className="userInfo">
                      <p className="name">{u.user_name}</p>
                      <p className="email">{u.email}</p>
                    </div>
                  </div>
                </td>

                <td>
                  <span className={`badge role-${u.role}`}>
                    {formatSystemRole(u.role)}
                  </span>
                </td>

                <td>
                  <span className="badge countryBadge">
                    {formatCountryLabel(u)}
                  </span>
                </td>

                <td>
                  <span
                    className={`badge status-${u.active_status === "온라인" ? "green" : u.active_status === "휴면" ? "gray" : "yellow"}`}
                  >
                    {u.active_status}
                  </span>
                </td>

                <td className="tRight">
                  <span className="muted">
                    {formatKoreanDateTime(u.last_login, { year: "numeric" })}
                  </span>
                </td>
              </tr>
            ))}

            {users.length === 0 && (
              <tr>
                <td colSpan={5} className="empty">
                  검색 결과가 없습니다.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="tableFooter">
        <span className="muted">총 {users.length}명</span>
        <span className="muted">
          선택됨:{" "}
          <b>
            {selectedUser
              ? `${selectedUser.user_name} (${formatSystemRole(selectedUser.role)})`
              : "-"}
          </b>
        </span>
      </div>
    </div>
  );
}
